export enum VisibilityToggleState {
  visible = 'visible',
  hidden = 'hidden'
}
